import { ExpressionParser } from "expressionparser"

export const formatAsMinSecs = (seconds) => {
    return new Date(seconds * 1000).toISOString().substr(14, 5)
}

const logicalExprLang = {
    AMBIGUOUS: { true: true, false: false },
    INFIX_OPS: { '&&': (a, b) => a() && b(), '||': (a, b) => a() || b() },
    PREFIX_OPS: { '!': expr => !expr() },
    PRECEDENCE: [['!'], ['&&'], ['||']],
    GROUP_OPEN: '(',
    GROUP_CLOSE: ')',
    SEPARATOR: ' ',
    SYMBOLS: ['(', ')', '!', '&&', '||'],
    termDelegate(term) {
        if (term === 'true') return true;
        if (term === 'false') return false;
        throw new Error(`invalid term ${term}`);
    }
}
export const logicalExprParser = new ExpressionParser(logicalExprLang);


